module.exports = __webpack_public_path__ + "static/mckinsey-f9615214ed54a9fecfd0d9edefd2dcc9.svg";